import { useEffect } from 'react'
import { useLocation } from 'react-router'

import { AMPLITUDE_EVENTS } from '../constants'
import useAmplitudeContext from './useAmplitudeContext'

/**
 * useGlobalTracker is a custom hook that tracks page views using Amplitude.
 * If you need to track event of specific page, you can adds this event in 
 * this hook.
 */
const useGlobalTracker = () => {
    const location = useLocation()
    const { trackAmplitudeEvent } = useAmplitudeContext()

    useEffect(() => {
        if (location.pathname) {
            trackAmplitudeEvent(
                AMPLITUDE_EVENTS.mainPageOpening,
                { page: location.pathname },
            )
            if (location.pathname === '/login') {
                trackAmplitudeEvent(
                    AMPLITUDE_EVENTS.loginScreenOpening,
                    { page: location.pathname },
                )
            }
            if (location.pathname === '/login/2fa/') {
                trackAmplitudeEvent(
                    AMPLITUDE_EVENTS.secondFactorScreenOpening,
                    { page: location.pathname },
                )
            }
            if (location.pathname === '/sign-up/') {
                trackAmplitudeEvent(
                    AMPLITUDE_EVENTS.signUpScreenOpening,
                    { page: location.pathname },
                )
            }
            if (location.pathname === '/sign-up/individual/') {
                trackAmplitudeEvent(
                    AMPLITUDE_EVENTS.signUpIndividualScreenOpening,
                    { page: location.pathname },
                )
            }
            if (location.pathname === '/sign-up/business/') {
                trackAmplitudeEvent(
                    AMPLITUDE_EVENTS.signUpBusinessScreenOpening,
                    { page: location.pathname },
                )
            }
            if (
                location.pathname === '/sign-up/individual/confirm-email/'
                ||
                location.pathname === '/sign-up/business/confirm-email/'
            ) {
                trackAmplitudeEvent(
                    AMPLITUDE_EVENTS.emailVerificationScreenOpening,
                    { page: location.pathname },
                )
            }
            if (
                location.pathname === '/sign-up/individual/registration-phone/'
                ||
                location.pathname === '/sign-up/business/registration-phone/'
            ) {
                trackAmplitudeEvent(
                    AMPLITUDE_EVENTS.phoneNumberScreenOpening,
                    { page: location.pathname },
                )
            }
            if (
                location.pathname === '/sign-up/individual/confirm-phone/'
                ||
                location.pathname === '/sign-up/business/confirm-phone/'
            ) {
                trackAmplitudeEvent(
                    AMPLITUDE_EVENTS.phoneNumberVerificationScreenOpening,
                    { page: location.pathname },
                )
            }
            if (location.pathname === '/sign-up/business/check-kyb/') {
                trackAmplitudeEvent(
                    AMPLITUDE_EVENTS.kybScreenOpening,
                    { page: location.pathname },
                )
            }
            if (location.pathname === '/sign-up/business/verification-pending/') {
                trackAmplitudeEvent(
                    AMPLITUDE_EVENTS.kybVerificationPendingScreenOpening,
                    { page: location.pathname },
                )
            }
        }
    }, [location.pathname, trackAmplitudeEvent, location])
}

export default useGlobalTracker
